export default __webpack_public_path__ + "static/media/warning--dangerous-crosswinds-left--g4.69cf0606.png";